import React from 'react';

export default function CompleteMessage({ message }) {
  return (
    <div>
      {message}
    </div>
  );
}